import { StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AuthClientConfig, provideAuth0 } from '@auth0/auth0-angular';
import { IEnvironmentConfig } from '@sondermind/configuration';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/* eslint-disable import/first */
// eslint-disable-next-line no-var, no-underscore-dangle
declare let __webpack_public_path__: string | undefined;

// The __webpack_public_path__ should already be set by index.html
// This code ensures it's configured correctly based on environment
if (environment.production) {
  __webpack_public_path__ = 'https://providers.sondermind.com/';
} else if (environment.staging) {
  // Keep the value set in index.html or use detection logic
  if (__webpack_public_path__ === 'DYNAMIC_STAGING_PUBLIC_PATH') {
    // Fallback: try to detect public path from script tags
    let publicPath = '';
    if (typeof document !== 'undefined') {
      const scripts = Array.from(document.getElementsByTagName('script'));
      const mainScript = scripts.find((script) => script.src && /\/main(\.[a-zA-Z0-9]+)?\.js$/.test(script.src));
      if (mainScript) {
        publicPath = mainScript.src.substring(0, mainScript.src.lastIndexOf('/') + 1);
      }
    }
    if (publicPath) {
      __webpack_public_path__ = publicPath;
    } else {
      // Use staging default fallback
      __webpack_public_path__ = `${window.location.protocol}//${window.location.host}/providers/`;
    }
  }
} else if (environment.preprod) {
  __webpack_public_path__ = 'https://bowie-providers.sondermind.biz/';
} else {
  __webpack_public_path__ = 'http://localhost:4205/';
}

// eslint-disable-next-line no-restricted-globals
const configUrl = `/assets/config/${location.host}.json`;

fetch(configUrl).then((response) => {
  if (!response.ok) {
    throw new Error(`Could not load config from ${configUrl}`);
  }
  return response.json();
}).then((config: IEnvironmentConfig) => {
  // Create your Auth0 configuration object from the loaded config
  const auth0Config = {
    domain: config.auth0Domain,
    clientId: config.auth0ClientToken,
    useRefreshTokens: true,
    cacheLocation: 'localstorage' as const,
    authorizationParams: {
      redirect_uri: config.clientPortalBase,
      audience: config.auth0Audience || 'https://monolith-api.com'
    },
  };

  // Now bootstrap the Angular app with the dynamic Auth0 config:
  platformBrowserDynamic([
    ...(provideAuth0(auth0Config) as StaticProvider[]),
    {
      provide: AuthClientConfig,
      useValue: {
        get: () => auth0Config
      }
    },
  ]).bootstrapModule(AppModule)
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
}).catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Error loading configuration in main', err);
});
